module.exports = __webpack_public_path__ + "img/tarj1-3.ae09772b.png";